import Footer from 'components/Footers/Footer'
import Navbar from 'components/Navbars/AdminNavbar';
import React, { useState, useRef, useEffect } from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import Swal from 'sweetalert2';
import BASE_URL from 'components/BaseUrl/apiConfig';

const UpdateSubUserbyAdmin = ({ location }) => {


    const history = useHistory();

    const userNameInputRef = useRef(null);


   // const { subuser } = location.state;
   const { subuser } = location.state || {};



   console.log(subuser);

    const [formData, setFormData] = useState({
        userId:subuser.userId,
        fullname: subuser.fullName,
        username: subuser.userName,
        email: subuser.emailId,
        password:subuser.password,
    });


    // const [formData, setFormData] = useState({
    //     userId: subuser?.userId || '',
    //     fullname: subuser?.fullName || '',
    //     username: subuser?.userName || '',
    //     email: subuser?.emailId || '',
    //     password: subuser?.password || '',
    // });
    

    const [validationMessages, setValidationErrors] = useState({
        fullname: '',
        username: '',
        email: '',
        password:'',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
        setValidationErrors((prevErrors) => ({
            ...prevErrors,
            [name]: '', // Clear the validation error when the user types
        }));
    };

    useEffect(() => {
        // Focus on the userName input when the component mounts
        userNameInputRef.current.focus();
    }, []);

    const validateForm = () => {
        let isValid = true;
        const newErrors = {};

        // Perform validation logic for each field
        if (formData.fullname.trim() === '') {
            newErrors.fullname = 'Full name is required.';
            isValid = false;
        }

        const usernameRegex = /^[a-z]+$/;// Regex for lowercase letters only
        if (formData.username.trim() === '') {
            newErrors.username = 'Username is required.';
            isValid = false;
        } else if (!usernameRegex.test(formData.username)) {
            newErrors.username = 'Username should only contain lowercase letters without spaces.';
            isValid = false;
        }

        if (formData.email.trim() === '') {
            newErrors.email = 'Email address is required';
            isValid = false;
        }
        else if (!isValidEmail(formData.email)) {
            newErrors.email = 'Email address is not valid.';
            isValid = false;
        }


        if (formData.password.trim() === '') {
            newErrors.password = 'Password  is required.';
            isValid = false;
        }

        setValidationErrors(newErrors);
        return isValid;
    };

    const isValidEmail = (email) => {
        // Use a regular expression for basic email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };


    const handleCreateAccount = async () => {

        // Validate the form before making the API call
        if (!validateForm()) {
            return;
        }
        // If all validations pass, proceed with the API request
        try {
            debugger
            const response = await fetch(`${BASE_URL}/api/SubUser/UpdateSubUserbyuser`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    userId:formData.userId,
                    groupId: 3,
                    fullname: formData.fullname,
                    userName: formData.username,
                    emailId: formData.email,
                    password:formData.password,
                }),
            });

            if (response.ok) {
                const data = await response.json();

                setFormData({
                    fullname: '',
                    username: '',
                    email: '',
                    password:'',
                });

                // Display SweetAlert success message
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Sub user updated successfully',
                });
                history.goBack();
            } else {
                const errorData = await response.json();
                // Handle error scenarios

                Swal.fire({
                    icon: 'error',
                    title: 'Failed',
                    text: 'Sub user Update failed!',
                });
            }
        } catch (error) {
            console.error('Error creating account:', error.message);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: (error.message),
            });
        }
    };

    return (
        <>
            <Navbar />
            <div className='cust-div'>
                <div className="container mx-auto px-4 h-full">
                    <div className="flex content-center items-center justify-center h-full">
                        <div className="w-full lg:w-6/12 px-4">
                            <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white border-0">
                                <div className="rounded-t mb-0 px-6 py-6">
                                    <div className="text-center mb-3">
                                        <h6 className="text-blueGray-800 text-sm text-3xl font-bold">
                                            Update Sub User
                                        </h6>
                                    </div>
                                    <hr className="mt-6 border-b-1 border-blueGray-300" />
                                    
                                </div>
                                <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
                                    <form>
                                        {/* FullName Input */}
                                        <div className="relative w-full mb-3">

                                            <input
                                                type="hidden"
                                                id="userId"
                                                value={formData.userId}
                                            />

                                            <label
                                                className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                                                htmlFor="fullname"
                                            >
                                                Full Name
                                            </label>
                                            <input
                                                type="text"
                                                id="fullname"
                                                name="fullname"
                                                ref={userNameInputRef}
                                                maxLength={50}
                                                value={formData.fullname}
                                                onChange={handleChange}
                                                className="border rounded w-full"
                                                placeholder="Full Name"
                                            />
                                            <div className="text-red-500 text-xs mt-1">
                                                {validationMessages.fullname}
                                            </div>
                                        </div>

                                        {/* UserName Input */}
                                        <div className="relative w-full mb-3">
                                            <label
                                                className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                                                htmlFor="username"
                                            >
                                                Username
                                            </label>
                                            <input
                                                type="text"
                                                id="username"
                                                name="username"
                                                maxLength={30}
                                                value={formData.username}
                                                onChange={handleChange}
                                                className="border rounded w-full"
                                                placeholder="Username"
                                                disabled 
                                                
                                            />
                                            <div className="text-red-500 text-xs mt-1">
                                                {validationMessages.username}
                                            </div>
                                        </div>

                                        {/* Email Input */}
                                        <div className="relative w-full mb-3">
                                            <label
                                                className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                                                htmlFor="email"
                                            >
                                                Email
                                            </label>
                                            <input
                                                type="email"
                                                id="email"
                                                name="email"
                                                maxLength={50}
                                                value={formData.email}
                                                onChange={handleChange}
                                                className="border rounded w-full"
                                                placeholder="Email"
                                                disabled 
                                            />
                                            <div className="text-red-500 text-xs mt-1">
                                                {validationMessages.email}
                                            </div>
                                        </div>


                                          {/* Email Input */}
                                          <div className="relative w-full mb-3">
                                            <label
                                                className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                                                htmlFor="password"
                                            >
                                                Password
                                            </label>
                                            <input
                                                type="password"
                                                id="password"
                                                name="password"
                                                maxLength={50}
                                                value={formData.password}
                                                onChange={handleChange}
                                                className="border rounded w-full"
                                                placeholder="Password"
                                                 
                                            />
                                            <div className="text-red-500 text-xs mt-1">
                                                {validationMessages.password}
                                            </div>
                                        </div>

                                        {/* Buttons */}
                                        <div className="text-right mt-6 flex flex-row justify-end">
                                            <button type="button" className="bg-lightBlue-500 text-white active:bg-lightBlue-600 text-xs font-bold uppercase px-4 py-2 mr-4 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" onClick={() => history.goBack()}>
                                                Back to Sub User list
                                            </button>
                                            <button
                                                className="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-3 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 sm:w-auto ease-linear transition-all duration-150"
                                                type="button"
                                                onClick={handleCreateAccount}
                                            >
                                                Update 
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default UpdateSubUserbyAdmin
